import { mockResultList } from './mock';

export default () => {
  return {
    resultList: mockResultList,
  };
};
